module.exports = __webpack_public_path__ + "img/bottom_windpower_001.c9f2b4cc.svg";